import { usePriceGuard } from '../../hooks/usePriceGuard.ts';
import { useI18n } from '../../i18n/index.tsx';
import { fmtBps } from '../../lib/format.ts';

/**
 * Shown on Stake and Referral while the pool's spot price and its average disagree by more than the bond guard:
 * what that means here (nothing pauses; stakes book the lower price, claims pay the higher) so the Swap page's
 * number is no surprise.
 */
export function PriceMoving() {
  const { t } = useI18n();
  const { guard } = usePriceGuard();
  if (!guard?.paused) return null;
  return (
    <div className="price-moving" role="status" data-testid="price-moving">
      <b>{t('price.moving', { dev: fmtBps(BigInt(guard.devBps)) })}</b> {t('price.movingRules')}
    </div>
  );
}
